import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor() {}

  /**
   * Affiche un toast de succès
   */
  success(message: string, title?: string): void {
    this.showToast('success', message, title);
  }

  /**
   * Affiche un toast d'erreur
   */
  error(message: string, title?: string): void {
    this.showToast('error', message, title);
  }

  /**
   * Affiche un toast d'avertissement
   */
  warning(message: string, title?: string): void {
    this.showToast('warning', message, title);
  }

  /**
   * Affiche un toast d'information
   */
  info(message: string, title?: string): void {
    this.showToast('info', message, title);
  }

  /**
   * Méthode générique pour afficher un toast
   */
  private showToast(type: ToastType, message: string, title?: string): void {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      },
    });

    Toast.fire({
      icon: type,
      title: title || message,
      text: title ? message : undefined,
    });
  }
}
